// extracted by mini-css-extract-plugin
export default {"search-next-prev":"search-next-prev_search-next-prev__jeCEn","search":"search-next-prev_search__cSihk","prev":"search-next-prev_prev__im6gJ","next":"search-next-prev_next__d-LIT"};